import React from "react";
import classNames from "classnames";
import { Dropdown } from "react-bootstrap";
import { ripple } from "../ripple";
import { helper } from "../utils";

interface ButtonProps {
    active?: boolean;
    variant?: "" | "inherit" | "contained" | "flat" | "icon" | "text" | "outline" | "fab";
    className?: string;
    color?: "" | "inherit" | "default" | "primary" | "secondary";
    size?: "" | "sm" | "md" | "lg";
    pill?: boolean;
    edge?: "start" | "end";
    menu?: any;
    align?: "start" | "end";
    drop?: "up" | "start" | "end" | "down";
    position?: "bottom-start" | "bottom-center" | "bottom-end";
    href?: string;
    disableRipple?: boolean;
    disabled?: boolean;
    children?: any;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
    onMouseLeave?: (e: any) => void;
    onMouseDown?: (e: any) => void;
    onClick?: (e: any) => void;
    [x: string]: any;
}

export const Button = ({
    active,
    variant,
    className,
    color,
    size,
    pill,
    edge,
    menu,
    drop,
    align,
    position,
    href,
    disableRipple,
    disabled,
    onFocus,
    onBlur,
    onMouseLeave,
    onMouseDown,
    onClick,
    children,
    ...props
}: ButtonProps) => {
    var cn = "btn ";
    //------
    var is_rtl = helper.isRTL();
    if (is_rtl) {
        switch (drop) {
            case "start":
                drop = "end";
                break;

            case "end":
                drop = "start";
                break;

            default:
                if (!align || align === "start") align = "end";
                else if (align === "end") align = "start";
        }
    }

    //------
    if (color === "inherit") color = "";
    else if (!color) color = "primary";

    if (!variant) variant = "text";
    //------
    if (variant === "icon") {
        cn += " btn-icon";
        if (color) cn += ` btn-text-${color}`;
    } else if (variant === "text") {
        cn += " btn-text";
        if (color) cn += ` btn-text-${color}`;
    } else if (variant === "outline") {
        cn += " btn-outline";
        if (color) cn += ` btn-outline-${color}`;
    } else if (variant === "fab") {
        cn += " btn-fab";
        if (color) cn += ` btn-${color}`;
    } else if (variant === "contained" || variant === "flat") {
        if (!!color) {
            cn += ` btn-contained btn-${color}`;
        }
    }
    cn = classNames(className, cn, {
        "rounded-circle": variant === "fab" && !pill,
        "btn-active": active,
        "btn-flat": variant === "flat",
        "btn-sm": size === "sm",
        "btn-md": size === "md",
        "btn-lg": size === "lg",
        "rounded-pill": pill,
        "btn-disabled": !!disabled,
        "pe-none": !!disabled && !!href,
        "btn-edge-start": edge === "start",
        "btn-edge-end": edge === "end",
        "dropdown-no-caret": (variant === "icon" || variant === "fab") && menu,
        "fab-start": position === "bottom-start",
        "fab-center": position === "bottom-center",
        "fab-end": position === "bottom-end",
    });

    var newProps;
    newProps = {
        onFocus: (e) => {
            if (!disableRipple) {
                ripple.focus(e.currentTarget);
            }
            if (onFocus) onFocus(e);
        },
        onBlur: (e) => {
            if (!disableRipple) {
                ripple.blur(e.currentTarget);
            }
            if (onBlur) onBlur(e);
        },
        onMouseLeave: (e) => {
            if (!disableRipple) {
                ripple.removeFocus(e.currentTarget);
            }
            if (onMouseLeave) onMouseLeave(e);
        },
        onMouseDown: (e) => {
            if (!disableRipple) {
                ripple.pulse(e.currentTarget, e.clientX, e.clientY);
            }
            if (onMouseDown) onMouseDown(e);
        },
    };
    if (onClick) newProps = { ...newProps, onClick };
    if (disabled) newProps = { ...newProps, disabled };
    if (menu) {
        var dropdownProps = { drop, align };
        return (
            <Dropdown {...dropdownProps}>
                <Dropdown.Toggle as="button" className={cn} {...newProps} {...props}>
                    {children}
                </Dropdown.Toggle>
                {menu}
            </Dropdown>
        );
    } else if (!!href)
        return (
            <a className={cn} href={href} {...newProps} {...props}>
                {children}
            </a>
        );
    return (
        <button className={cn} {...newProps} {...props}>
            {children}
        </button>
    );
};
